


if (!customElements.get('product-custom-part-picker')) {

    class ProductPartPicker extends HTMLElement {

        constructor() {
            super();
        }
        connectedCallback() {
            this.processDulicateTab();

        }
        disconnectedCallback() {
        }

        openTab(tabName) {
            var i, tabcontent, tablinks;

            tabcontent = document.getElementsByClassName('tabcontent');
            for (i = 0; i < tabcontent.length; i++) {
                tabcontent[i].style.display = 'none';
            }
            tablinks = document.getElementsByClassName('product-part-tab');
            for (i = 0; i < tablinks.length; i++) {
                tablinks[i].className = tablinks[i].className.replace(' active', '');
            }
            document.getElementById('tab-' + tabName).style.display = 'block';

            document.getElementById("btn-part-" + tabName).className += " active"
            // evt.currentTarget.className += ' active';
        }


        setActivePart(partName, partValue) {
            var lsChilds = document.getElementsByTagName("product-part-button");
            for (let index = 0; index < lsChilds.length; index++) {
                const element = lsChilds[index];
                if (element.dataset.part == partName && element.dataset.partvalue == partValue) {
                    element.querySelector("input")
                    element.querySelector("input").setAttribute("checked", "true");
                }
            }
            // document.getElementById("btn-part-value-" + partName + "-" + partValue)?.setAttribute("checked", "true");
        }
        processDulicateTab() {
            // var tabContainer = this.querySelector(".container-tab-content");
            // var nodes = tabContainer.childNodes;
            // console.log(nodes);
            // var tabRendered = {}
            // for (let index = 0; index < nodes.length; index++) {
            //     const element = nodes[index];
            //     if (tabRendered[element.id] != undefined) {
            //         const nodeChild = element.childNodes;
            //         element.style.display = "block"
            //         for (const child of element.childNodes) {
            //             tabRendered[element.id].append(child);
            //         }

            //         // element.remove();
            //     } else {
            //         tabRendered[element.id] = element;

            //     }

            // }
        }
    }

    customElements.define(
        'product-custom-part-picker', ProductPartPicker)
}
